function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "currentColor",
  d: "M7.179,11.128,10.26,8.083,1.066,8.041A1.07,1.07,0,0,1,0,6.965H0A1.07,1.07,0,0,1,1.076,5.9l9.192.041L7.228,2.865a1.07,1.07,0,0,1,.006-1.514h0a1.072,1.072,0,0,1,1.515.007l5,5.049a.879.879,0,0,1-.007,1.243l-5.053,5a1.071,1.071,0,0,1-1.514-.007h0A1.071,1.071,0,0,1,7.179,11.128Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/arrow-right-2.7bd7582f.svg";
export { SvgComponent as ReactComponent };